// base
export const GET_BASE_INFO = '/apps/users/get_base_info'
export const WX_REDIRECTOR = '/api/v1/wechat_applet/auto_login'

// file item info
export const FILE_INFO = '/apps/files/get_info'
export const SECURITY_INFO = '/apps/files/get_security_info'
export const DELETE_FILE = '/apps/files/delete'
export const EDIT_FILE = '/apps/files/edit'
export const NEW_FOLDER = '/apps/files/new_folder'
export const FILE_INFO_NEW = '/galaxy/item/info'

export const UPDATE_ENTERPRISE_SETTINGS = '/admin/enterprise_settings/update'
export const EDIT_DEPARTMENT_INFO = '/admin/departments/edit'
export const UPDATE_USER_SETTINGS = '/user_settings/update'

// file list
export const FILE_LIST = '/apps/files/file_list'
export const TRASH_LIST = '/apps/files/trash_list'
export const FILE_LIST_COLLAB = '/apps/files/file_list_for_collabs'
export const ISOLATION_LIST = '/apps/files/isolation_list'
export const EXTERNAL_ENTERPRISE_FILES = '/apps/files/file_list_for_external_enterprise'
export const FIND_USER_DEPARTMENTS = '/departments/find_user_in_departments_tree'

// frequent
export const FREQUENT_SPACE_INFO = '/apps/frequently_used_items/get_space_info'
export const FREQUENT_LIST = '/apps/frequently_used_items/get_list'
export const FREQUENT_SET = '/apps/frequently_used_items/top'
export const FREQUENT_ADD = '/apps/frequently_used_items/add'
export const FREQUENT_DELETE = '/apps/frequently_used_items/delete'

// departments list, info
export const DEPARTMENT_LIST = '/departments/get_departments_list'
export const DEPARTMENT_INFO = '/departments/info'
export const DEPARTMENT_MEMBER = '/departments/user_list'

export const EXTERNAL_ENTERPRISES = '/enterprises/get_external_enterprises'

// preview
export const MARK_AS_USED = '/recent_items/mark_as_used'
export const PREVIEW_GENERATE_INFO = '/apps/representations/info'
// 开放平台的preview info，和PREVIEW_GENERATE_INFO类似
export const OPENPLATFORM_PREVIEW_INFO = '/api/v2/preview/info'

export const GET_SIBLING = '/apps/files/get_sibling'
export const DOWNLOAD_VERSION = '/apps/file_versions/download'
export const DOWNLOAD_FILE = '/apps/files/download'
export const PACK_DOWNLOAD = '/pack_download/download'
export const GET_YQX_URL = '/yiqixie/get_access_url'

// version
export const VERSIONS_INFO = '/apps/files/versions'
export const VERSIONS_SET = '/apps/files/set_current_version'
export const VERSIONS_DELETE = '/apps/files/delete_version'

// trash
export const RESTORE_FILE = '/apps/files/restore_from_trash'
export const PERMANENT_DELETE_FILE = '/apps/files/delete_from_trash'

// upload
export const PRESIGN_UPLOAD = '/apps/files/presign_upload'
export const GET_UPLOAD_TASK = '/apps/files/presign_upload'
export const DETECT_FILE_NAME = '/apps/files/detect_file_names'
export const ABORT_RESUMABLE_UPLOAD = '/abort_resumable_upload'
export const GET_START_POSITION = '/get_start_position'
export const FINISH_RESUMABLE_UPLOAD = '/finish_resumable_upload'

// search
export const FILE_SEARCH = '/apps/files/search'
export const DEPARTMENT_SEARCH = '/departments/search'

// move copy
export const MOVE_FILE = '/apps/files/move'
export const COPY_FILE = '/apps/files/copy'
export const SAVE_FILE = '/apps/files/copy?scenario=share'

// sharing
export const CREATE_SHARE = '/apps/share_links/create'
export const UPDATE_SHARE = '/apps/share_links/update'
export const UPGRADE_SHARE = '/auth/register_enterprise_edition'
export const GET_SHARE_LINK = '/apps/share_links/info'
export const GET_SHARE_USER_INFO = '/apps/users/get_share_user_info'
export const GET_INFORE_MEMBER_LIST = '/apps/users/get_infore_member_list'

// comment
export const COMMENTS_INFO = '/apps/files/comments'
export const COMMENTS_CREATE = '/apps/comments/create'
export const COMMENTS_DELETE = '/apps/comments/delete'

// review_comment
export const REVIEWS_COMMENTS_INFO = '/apps/reviews/comments'
export const REVIEWS_COMMENTS_CREATE = '/apps/review_comments/create'
export const REVIEWS_COMMENTS_DELETE = '/apps/review_comments/delete'

// message
export const MESSAGES_INFO = '/apps/messages/get_list'
export const MESSAGES_MARK_READ = '/apps/messages/mark_read'
export const MESSAGES_DELETE = '/apps/messages/delete'
export const MESSAGES_DETAIL = '/apps/messages/get'
export const CHILD_MESSAGES_LIST = '/apps/messages/child_messages_list'
export const CHILD_MESSAGES_MARK_READ = '/apps/messages/child_messages_mark_read'
export const CHILD_MESSAGES_DELETE = '/apps/messages/child_messages_delete'
export const GET_COLLAB = '/apps/collabs/get'
export const ACCEPT_COLLAB = '/apps/collabs/accept'

// contact select
export const DEPT_USER_LIST = DEPARTMENT_MEMBER
export const GET_CONTACTS = '/apps/contacts/get'

// guide
export const USER_GUIDE_SETTING = '/apps/users/update_user_guide_settings'

// collabs
export const COLLAB_INFO_ON_ITEM = '/apps/folders/get_collab_info_on_item'
export const GET_FILE_MANAGER_LIST = '/departments/manager_list'

// card
export const CARDS_USER_INFO = '/cards/user_info'
export const CARDS_DEPARTMENT_INFO = '/cards/department_info'
export const CARDS_GROUP_INFO = '/cards/group_info'
export const COLLAB_EDIT = '/apps/collabs/edit'
export const COLLAB_DELETE = '/apps/collabs/delete'
export const COLLAB_INVITE = '/apps/collabs/invite'

// log
export const LOG_ACTION = '/apps/logs/action'

export const APP_STORE_ENTER = '/app_store/enter_by_id'

// share_link get password
export const GET_SHARE_LINK_PASSWORD = '/apps/share_links/pass'

// collection
export const GET_COLLECTION_INFO = '/apps/processes/get_info'
export const COLLECTION_PRESIGN_UPLOAD = '/apps/processes/presign_upload'
export const COLLECTION_SUBMIT = '/apps/processes/collection_submit'

// review
export const GET_REVIEW_ITEM = '/apps/reviews/get_item_list'
export const GET_REVIEW_COMMENTS = '/apps/reviews/comments'
export const REVIEW_SUBMIT = '/apps/reviews/submit'
export const CLOSE_REVIEW = '/apps/reviews/close'

// workflow
export const GET_TASK_DETAIL = '/ark/app/workflow/getTaskDetail'
export const WORKFLOW_APPROVAL = '/ark/app/workflow/approval'

// 行业数据
export const REGISTER_INDUSTRY_INFO = '/apps/enterprise_homepage/enterprise_register_industry_info'
export const NEW_HOMEPAGE_DATA = '/apps/enterprise_homepage/enterprise_new_homepage_data'
export const EDIT_HOMEPAGE_DATA = '/apps/enterprise_homepage/enterprise_edit_homepage_data'

export const MOBILE_INVITE = '/apps/referral/mobile_invite'

export const LIBRARY_LIST = 'kbase/library/list'
export const HOMEPAGE_COLLECT = 'kbase/homepage/collect'
export const SEARCH_FILES = 'kbase/search/files'
export const LIBRARY_INFO = 'kbase/library/info'
export const META_TAG_LIST = 'kbase/meta/tag_list'
export const META_ADVICE_TAG_LIST = 'kbase/meta/advice_tag_list'
export const DOCUMENT_TREE = 'kbase/document/tree'
export const LIBRARY_USER_PERMISSIONS = 'kbase/library_user/permissions'
export const BOOK_PREVIEW = 'kbase/book/preview'
export const BOOK_INFO = 'kbase/book/info'
export const PREVIEW_GETSWITCH = '/venus/preview/getSwitch'
export const PREVIEW_PREVIEWINFO = '/venus/preview/getPreviewInfo'
export const SEARCH_LIBRARY = 'kbase/search/library'
export const DOCUMENT_DELETE = 'kbase/document/delete'
export const BOOK_PRESIGN_DOWNLOAD = 'kbase/book/presign_download'
export const KBASE_USER_INFO = 'kbase/user/info'
